import { MealTypeConfig, MealPlanConfig } from '@/types/meal-plan';

// Empty default configurations - no predefined meal types
export const defaultMealTypeConfigs: MealTypeConfig[] = [];

export const defaultMealPlanConfig: MealPlanConfig = {
  mealTypes: [],
  defaultCalories: 0,
  totalDailyKcal: 0
};

export const getMealTypeConfig = (type: string): MealTypeConfig | undefined => {
  return undefined; // No default configurations
};

export const getMealColor = (type: string): string => {
  return '#1EAEDB'; // Default color only
};
